'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _TitleAndText2 = require('./TitleAndText');

var _TitleAndText3 = _interopRequireDefault(_TitleAndText2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var MethodSummary = function (_TitleAndText) {
	_inherits(MethodSummary, _TitleAndText);

	function MethodSummary(props) {
		_classCallCheck(this, MethodSummary);

		var _this = _possibleConstructorReturn(this, (MethodSummary.__proto__ || Object.getPrototypeOf(MethodSummary)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(MethodSummary, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setState({
				heading: this.intl.formatMsg('Summary'),
				text: this.props.method.summary
			});
		}
	}]);

	return MethodSummary;
}(_TitleAndText3.default);

MethodSummary.propTypes = {
	/**
  * Swagger 2.0 method
  */
	method: _propTypes2.default.object.isRequired
};

var _default = (0, _reactIntl.injectIntl)(MethodSummary);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(MethodSummary, 'MethodSummary', 'src/components/SwaggerUI/MethodSummary.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodSummary.jsx');
}();

;